var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMongodb2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.7,8.59C21.46,4.77,18.67,.86,18.1,.05c-.04-.06-.12-.07-.18-.03-.01,0-.02,.02-.03,.03-.57,.8-3.36,4.71-6.6,8.53-27.76,35.37,4.38,59.23,4.38,59.23l.26,.18c.24,3.69,.85,9,.85,9h2.42s.6-5.28,.85-8.97l.26-.21s32.14-23.86,4.38-59.23Zm-6.7,58.71h0s-1.44-1.23-1.83-1.85v-.07l1.74-38.51c0-.05,.04-.09,.09-.09,.05,0,.08,.04,.09,.09l1.74,38.51v.07c-.39,.62-1.83,1.85-1.83,1.85Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodb2);
export default __webpack_public_path__ + "static/media/mongodb2.178ab106d08c663ed6dd3cbd2f8b4ec6.svg";
export { ForwardRef as ReactComponent };